import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const services = [
    {
      title: 'IT Consulting',
      icon: '💼',
      description: 'Expert technology consulting to drive your business forward with innovative solutions and strategic planning.'
    },
    {
      title: 'Hardware Solutions',
      icon: '🖥️',
      description: 'Comprehensive hardware infrastructure including servers, workstations, and networking equipment for businesses of all sizes.'
    },
    {
      title: 'Network Infrastructure',
      icon: '🌐',
      description: 'Design, implementation, and maintenance of robust network infrastructure to keep your business connected and secure.'
    },
    {
      title: 'Cloud Services',
      icon: '☁️',
      description: 'Scalable cloud solutions for data storage, backup, and computing resources tailored to your business needs.'
    },
    {
      title: 'Cybersecurity',
      icon: '🔒',
      description: 'Advanced security solutions to protect your business from cyber threats and ensure data integrity.'
    },
    {
      title: 'IT Support & Maintenance',
      icon: '🛠️',
      description: '24/7 technical support and maintenance services to keep your systems running smoothly and efficiently.'
    }
  ];

  const features = [
    { title: 'Experienced Team', description: 'Our certified professionals bring years of industry expertise to every project.' },
    { title: 'Quality Products', description: 'We partner with leading manufacturers to provide top-tier hardware solutions.' },
    { title: 'Customer Focused', description: 'Your satisfaction is our priority with dedicated support and personalized service.' },
    { title: 'Competitive Pricing', description: 'Get the best value for your investment with our transparent pricing models.' }
  ];

  return (
    <div className="App">
      {/* Navigation Bar */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="logo">
            <span className="logo-icon">⚡</span>
            <span className="logo-text">Apex Bit Solutions</span>
          </div>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            ☰
          </button>

          <ul className={`nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li><a onClick={() => scrollToSection('home')}>Home</a></li>
            <li><a onClick={() => scrollToSection('about')}>About</a></li>
            <li><a onClick={() => scrollToSection('services')}>Services</a></li>
            <li><a onClick={() => scrollToSection('why-us')}>Why Us</a></li>
            <li><a onClick={() => scrollToSection('contact')}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <p style={{ color: 'yellow' }} className="hero-description"><i>Under Maintenance</i></p>
          <h1 className="hero-title">Welcome to Apex Bit Solutions</h1>
          <p className="hero-subtitle">Your Trusted Partner in Hardware & IT Services</p>
          <p className="hero-description">
            Empowering businesses with cutting-edge technology solutions and exceptional service
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => scrollToSection('services')}>
              Explore Services
            </button>
            <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
              Get in Touch
            </button>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="section-header">
            <h2>About Apex Bit Solutions</h2>
            <div className="section-underline"></div>
          </div>
          <div className="about-content">
            <div className="about-text">
              <h3>Driving Innovation Since Inception</h3>
              <p>
                Apex Bit Solutions is a registered company specializing in comprehensive hardware and IT services. 
                We are committed to delivering excellence through innovative technology solutions that help businesses 
                thrive in the digital age.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore 
                et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut 
                aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse 
                cillum dolore eu fugiat nulla pariatur.
              </p>
              <p>
                Our mission is to provide reliable, scalable, and cost-effective technology solutions that empower 
                businesses to achieve their goals and maintain a competitive edge in their industries.
              </p>
            </div>
            <div className="about-image">
              <img src="https://via.placeholder.com/500x400/0066cc/ffffff?text=Apex+Bit+Solutions" alt="About Us" />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <div className="section-underline"></div>
            <p className="section-description">
              Comprehensive technology solutions tailored to meet your business needs
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section id="why-us" className="why-us">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Us</h2>
            <div className="section-underline"></div>
          </div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-number">{index + 1}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Expert Team Members</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="section-header">
            <h2>Get in Touch</h2>
            <div className="section-underline"></div>
            <p className="section-description">
              Ready to transform your business with our IT solutions? Contact us today!
            </p>
          </div>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h4>Address</h4>
                  <p>123 Business Street, Tech City, TC 12345</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h4>Phone</h4>
                  <p>+1 (555) 123-4567</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div>
                  <h4>Email</h4>
                  <p>info@apexbitsolutions.com</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">⏰</div>
                <div>
                  <h4>Business Hours</h4>
                  <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
                  <p>Saturday: 10:00 AM - 4:00 PM</p>
                </div>
              </div>
            </div>
            <div className="contact-form">
              <form>
                <div className="form-group">
                  <input type="text" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                  <input type="text" placeholder="Subject" required />
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Message" rows="5" required></textarea>
                </div>
                <button type="submit" className="btn btn-primary">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Apex Bit Solutions</h3>
              <p>Your trusted partner in hardware and IT services. Delivering excellence through innovation.</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a onClick={() => scrollToSection('home')}>Home</a></li>
                <li><a onClick={() => scrollToSection('about')}>About</a></li>
                <li><a onClick={() => scrollToSection('services')}>Services</a></li>
                <li><a onClick={() => scrollToSection('contact')}>Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li>IT Consulting</li>
                <li>Hardware Solutions</li>
                <li>Network Infrastructure</li>
                <li>Cloud Services</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Connect With Us</h4>
              <div className="social-links">
                <a href="#" className="social-icon">📘</a>
                <a href="#" className="social-icon">🐦</a>
                <a href="#" className="social-icon">💼</a>
                <a href="#" className="social-icon">📷</a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2026 Apex Bit Solutions. All rights reserved. | Registered Company</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
